/** How long a sync JWT lives; the provider refreshes via /api/auth/sync-token. */
export const SYNC_TOKEN_TTL_SECONDS = 15 * 60;
/** Magic-link token lifetime. */
export const MAGIC_LINK_TTL_MINUTES = 15;
export const API_PREFIX = "/api";
export const SYNC_PATH = "/sync";
//# sourceMappingURL=protocol.js.map